import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  MenuItemWrapper,
  MenuItemLink,
  MenuItemButton,
  MenuItemLabel,
  MenuItemIconWrap,
  SubMenuList,
  SubMenuItemLink,
} from './styles'
import { SidebarMenuItem as SidebarMenuItemType } from './types'
import { useSmartNavigate } from '../../../smartNav/useSmartNavigate'

interface Props {
  item: SidebarMenuItemType
  isOpen: boolean
  iconSize?: string
  itemGap?: string
}

export const SidebarMenuItem = ({ item, isOpen, iconSize, itemGap }: Props) => {
  const smartNavigate = useSmartNavigate()

  const content = (
    <>
      {item.icon && (
        <MenuItemIconWrap $iconSize={iconSize}>
          <FontAwesomeIcon icon={item.icon} />
        </MenuItemIconWrap>
      )}
      <MenuItemLabel $visible={isOpen}>{item.title}</MenuItemLabel>
    </>
  )

  return (
    <MenuItemWrapper $active={item.active} $gap={itemGap}>
      {item.path && !item.isSubMenu ? (
        <MenuItemLink
          to={item.path}
          $isOpen={isOpen}
          onClick={(e) => {
            e.preventDefault()
            smartNavigate(item.path!)
            item.onClick?.()
          }}
        >
          {content}
        </MenuItemLink>
      ) : (
        <MenuItemButton 
            type="button" 
            $isOpen={isOpen} 
            onClick={item.onClick} 
            title={!isOpen ? item.title : undefined}
          >
          {content}
        </MenuItemButton>
      )}

      {item.isSubMenu && item.accordionOpen && item.subMenuItems && isOpen && (
        <SubMenuList>
          {item.subMenuItems.map((sub, i) => (
            <li key={i}>
              {sub.path ? (
                <SubMenuItemLink
                  to={sub.path}
                  onClick={(e) => {
                    e.preventDefault()
                    smartNavigate(sub.path!)
                  }}
                >
                  {sub.title}
                </SubMenuItemLink>
              ) : (
                <span style={{ display: 'block', padding: '0.5rem 1rem', color: 'rgba(255,255,255,0.75)', fontSize: 13 }}>
                  {sub.title}
                </span>
              )}
            </li>
          ))}
        </SubMenuList>
      )}
    </MenuItemWrapper>
  )
}
